/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : CustomButton.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author : Narender - narender@au79consulting.com
 * @Date : 17-06-2024
 * @description Reusable button component.
 */

import { Button } from "@mui/material";
import React from "react";
import appTheme from "../../assets/AppTheme/appTheme";

/**
 * @author : Narender - narender@au79consulting.com
 * @Date : 17-06-2024
 * @description Reusable button component.
 * @param { size, variant, btnName, handleOnClick, btnStyle }
 * @return The rendered button component.
 */
function CustomButton({
  endIcon,
  startIcon,
  size,
  variant,
  btnName,
  handleOnClick,
  disabled = false,
  btnStyle,
}) {
  return (
    <Button
      size={size}
      variant={variant}
      onClick={handleOnClick}
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}
      sx={{
        ...appTheme.commonBtnStyle,
        textTransform: "none",
        fontWeight: 600,
        fontSize: "12px",
        borderRadius: 8,
        paddingY: 1,
        boxShadow:
          variant === "contained" ? "0px 2px 8px rgba(0, 0, 0, 0.15)" : "none",
        ...(btnStyle || {}),
      }}
    >
      {btnName}
    </Button>
  );
}

export default CustomButton;
